// ---------------------------------------------------------------------product page drondown icon---------------------
document.querySelectorAll('.select select').forEach(select => {
  const wrapper = select.closest('.select');

  select.addEventListener('mousedown', () => {
    wrapper.classList.toggle('open');
  });

  select.addEventListener('blur', () => {
    wrapper.classList.remove('open');
  });

  select.addEventListener('change', () => {
    wrapper.classList.remove('open');
  });
});

/* INTACT: mobile media progress bar */
(function () {
  var MOBILE_QUERY = '(max-width: 749px)';

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  /* Height the media occupies at the current slide width.
     This is worked out from the file's own dimensions, not from the rendered
     box, so setting the track height can never feed back into the measurement
     and drift. Falls back to the rendered box only when dimensions are absent. */
  function slideMediaHeight(slide, slider) {
    if (!slide) return 0;

    var width = slide.clientWidth || slider.clientWidth || 0;
    if (width < 1) return 0;

    var img = slide.querySelector('img');
    if (img && img.naturalWidth > 0 && img.naturalHeight > 0) {
      return width * (img.naturalHeight / img.naturalWidth);
    }

    var video = slide.querySelector('video');
    if (video && video.videoWidth > 0 && video.videoHeight > 0) {
      return width * (video.videoHeight / video.videoWidth);
    }

    var media = slide.querySelector('.media');
    if (media) {
      var mediaHeight = media.getBoundingClientRect().height;
      if (mediaHeight > 1) return mediaHeight;
    }

    return slide.getBoundingClientRect().height;
  }

  /* The slide closest to the centre of the viewport is the one being looked at. */
  function activeSlide(slider) {
    var slides = slider.querySelectorAll('.product__media-item');
    if (!slides.length) return null;

    var centre = slider.scrollLeft + slider.clientWidth / 2;
    var best = slides[0];
    var bestDistance = Infinity;

    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i];
      var slideCentre = slide.offsetLeft + slide.offsetWidth / 2;
      var distance = Math.abs(slideCentre - centre);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = slide;
      }
    }

    return best;
  }

  function initIntactMediaProgress() {
    document.querySelectorAll('.intact-media-progress').forEach(function (bar) {
      var wrapper = bar.closest('.product__media-wrapper');
      if (!wrapper) return;
      var slider = wrapper.querySelector('.product__media-list');
      var fill = bar.querySelector('.intact-media-progress__fill');
      if (!slider || !fill) return;

      /* Guard against double binding when a section reloads in the editor. */
      if (slider.dataset.intactProgressBound === 'true') return;
      slider.dataset.intactProgressBound = 'true';

      var frame = null;

      /* Slides all sit in one row, so the row is as tall as the tallest image
         and a shorter image leaves white space under it. Setting the track to
         the height of the image in view removes that gap and puts the bar back
         on the image edge.

         The track already scrolls sideways, so giving it a height would also
         let it scroll up and down and the image could be dragged inside the
         frame. The vertical axis is locked here to prevent that. */
      function syncHeight() {
        if (!isMobile()) {
          slider.style.height = '';
          slider.style.overflowY = '';
          return;
        }

        slider.style.overflowY = 'hidden';

        var slide = activeSlide(slider);
        var height = slideMediaHeight(slide, slider);
        if (height > 1) {
          slider.style.height = Math.round(height) + 'px';
        }
      }

      function updateFill() {
        var max = slider.scrollWidth - slider.clientWidth;
        var pct;
        if (max <= 1) {
          var items = slider.querySelectorAll('.product__media-item').length;
          pct = items > 1 ? 100 / items : 100;
        } else {
          pct = (slider.scrollLeft / max) * 100;
          // show a minimum sliver so the bar reads as a position indicator
          var items2 = slider.querySelectorAll('.product__media-item').length || 1;
          var minPct = 100 / items2;
          pct = minPct + (pct * (100 - minPct)) / 100;
        }
        fill.style.width = Math.max(0, Math.min(100, pct)) + '%';
      }

      function update() {
        updateFill();
        syncHeight();
      }

      function scheduleUpdate() {
        if (frame) return;
        frame = window.requestAnimationFrame(function () {
          frame = null;
          update();
        });
      }

      slider.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate);
      window.addEventListener('orientationchange', scheduleUpdate);

      /* Images arrive late on mobile, so remeasure as each one loads. */
      slider.querySelectorAll('img').forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) return;
        img.addEventListener('load', scheduleUpdate);
        img.addEventListener('error', scheduleUpdate);
      });

      window.addEventListener('load', scheduleUpdate);
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIntactMediaProgress);
  } else {
    initIntactMediaProgress();
  }
  document.addEventListener('shopify:section:load', initIntactMediaProgress);
})();
